import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NewCardcomp from "../../../components/card/NewCardcomp";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import { useGetTokenOrLogout } from "../../../utils/token";
import CircularComponent from "../Components/CircularComp";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomPopup from "../../../components/CustomPopup";
import LeadAssignConverted from "../../../newTestPrep/pages/AdvisorTaskWiseReport/LeadAssignConverted";
import NewEnquiryComp from "../popupComponent/NewEnquiryComp";
import EnrollDetails from "../popupComponent/EnrollDetails";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function LeadToEnrol({
  handleDateChange1,
  loading,
  leadData,
  chosenDate,
}) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    console.log("clicked");
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter_type: cardFilter,

      date: chosenDate,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/fetch-lead-conversion-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  console.log("choosendate", chosenDate);

  const dateString = chosenDate;
  const date = new Date(dateString);

  // Get month (0-based, so add 1 if you want 1-12)
  const month = date.toLocaleString("default", { month: "long" });

  // Get year
  const year = date.getFullYear(); // 2025

  return (
    <>
    <LoaderComp isLoading={detailsLoading}/>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NewCardcomp>
            <Typography
              variant="subtitle2"
              sx={{ color: "#000000", textAlign: "center" }}
            >
              Lead To Enrollment Conversion Breakdown
            </Typography>
          </NewCardcomp>
        </Grid>

        <Grid item xs={12}>
          <NewCardcomp height="340px">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <LeadCalandar onDateChange={handleDateChange1} />
              </Grid>
              {loading ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mt={2}
                  width="100%"
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <CircularComponent
                    data1={leadData?.new_enquiry}
                    data2={leadData?.enrolled_student}
                    data3={leadData?.prev_month_enrollment}
                  />

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FF4B4B",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">Leads Assigned</Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography
                      variant="h6"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        getCardMoreInfo("Lead Assign", "new_enquiry")
                      }
                    >
                      {leadData?.new_enquiry}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#01BE85",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">Leads Converted</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    onClick={() =>
                      getCardMoreInfo("Leads Converted", "enrolled_student")
                    }
                  >
                    <Typography variant="h6" style={{ cursor: "pointer" }}>
                      {leadData?.enrolled_student}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FABA3A",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">
                      Leads Converted <br />
                      (Previous Assignments)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    onClick={() =>
                      getCardMoreInfo(
                        "Leads Converted (Previous Assignments)",
                        "prev_month_enrollment"
                      )
                    }
                  >
                    <Typography variant="h6" style={{ cursor: "pointer" }}>
                      {leadData?.prev_month_enrollment}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </NewCardcomp>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          selectedcardFilter === "new_enquiry" ? (
            <NewEnquiryComp
              onClose={handleCloseDetailPopup}
              SelectedData={SelectedCardData}
              selectedFilter="default"
              monthName={month}
              selectedYear={year}
            />
          ) : (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              SelectedCardData={SelectedCardData}
              selectedFilter="default"
              monthName={month}
              selectedYear={year}
            />
          )
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
